import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UserClassesTaken } from '@models/user-classes-taken';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-course-progress-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-course-progress-table.component.html',
  styleUrl: './app-course-progress-table.component.css'
})
export class AppCourseProgressTableComponent {
  @Input() userClasses: UserClassesTaken[] = [];
  @Input() editMode: boolean = false;
  @Output() saveChanges = new EventEmitter<void>();
  @Output() editModeChange = new EventEmitter<boolean>();

  getAvailableDate(item: UserClassesTaken): string {
    // Assuming available date logic - you may need to adjust based on your business logic
    return 'Available'; // Replace with actual logic
  }

  getStartedDate(item: UserClassesTaken): string {
    return item.whenClassStarted ? new Date(item.whenClassStarted).toLocaleDateString() : 'N/A';
  }

  getCompletedDate(item: UserClassesTaken): string {
    return item.whenClassCompleted ? new Date(item.whenClassCompleted).toLocaleDateString() : 'N/A';
  }

  toggleEditMode(): void {
    this.editMode = !this.editMode;
    this.editModeChange.emit(this.editMode);
  }

  onSave(): void {
    this.saveChanges.emit();
    this.editMode = false;
    this.editModeChange.emit(this.editMode);
  }

  onCancel(): void {
    this.editMode = false;
    this.editModeChange.emit(this.editMode);
  }
}
